import React from 'react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { heroBullets, heroQuestions } from '../data/audit';
export function ChairProblem() {
  return <section className="bg-cream-100 px-4 py-14 sm:px-6 sm:py-20" data-id="element-86" data-mp="28ntmcgp9n4pd">
      <div className="mx-auto w-full max-w-5xl" data-id="element-87" data-mp="28q68z75yy38r">
        <SectionHeading eyebrow="The moment it starts" title="When a complex rehab case sits in your chair…" subtitle="Can you review the entire case without going back through hours of notes?" data-id="element-88" data-mp="23qa312dpo1qk" />

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-89" data-mp="2wg0l1migrnry">
          <div className="rounded-3xl bg-white p-6 ring-1 ring-navy-900/10 sm:p-8" data-id="element-90" data-mp="2rm5v41c9mckf">
            <p className="text-sm font-bold uppercase tracking-[0.12em] text-navy-700/60" data-id="element-91" data-mp="2mow80sccmczr">
              A patient presents with
            </p>
            <ul className="mt-4 space-y-3" data-id="element-92" data-mp="3k4tar18hsze4">
              {heroBullets.map(b => <li key={b} className="flex items-start gap-3" data-id="element-93" data-mp="3fb78m2zygdwk">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-clay" aria-hidden="true" data-id="element-94" data-mp="2l3ixpjsrpdk9" />
                  <span className="text-[15px] font-medium leading-snug text-navy-900 sm:text-base" data-id="element-95" data-mp="2p777880ymj85">
                    {b}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy-900 p-6 sm:p-8" data-id="element-96" data-mp="21g1rrtyxlsyd">
            <p className="text-sm font-bold uppercase tracking-[0.12em] text-gold-400" data-id="element-97" data-mp="21egwg24sm5zg">
              And several questions appear at once
            </p>
            <ul className="mt-4 space-y-3" data-id="element-98" data-mp="1sfvhsi2fzb3y">
              {heroQuestions.map(q => <li key={q} className="rounded-xl bg-white/5 px-4 py-3 font-display text-[15px] italic leading-snug text-cream-50 sm:text-base" data-id="element-99" data-mp="1xdokv28g7p00">
                  {q}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-3xl space-y-4 text-center text-base leading-relaxed text-navy-700/85 sm:text-lg" data-id="element-100" data-mp="3pe2klamlvokl">
          <p data-id="element-101" data-mp="3lb6881nnsop3">This is where even experienced dentists can feel uncertain.</p>
          <p data-id="element-102" data-mp="3gc30g9gao4df">Not necessarily because they lack knowledge.</p>
          <p data-id="element-103" data-mp="3gepix44q44af">
            But because complex rehabilitation cases contain multiple variables
            that need to be organized and reviewed in a{' '}
            <strong className="font-bold text-navy-900" data-id="element-104" data-mp="cuukjv54nelc">logical sequence</strong>.
          </p>
          <p className="font-display text-xl font-bold text-navy-900 sm:text-2xl" data-id="element-105" data-mp="7y46fdcvut2k">
            That’s why Dr. Karito created the Complex Rehab Case Audit™.
          </p>
          <p data-id="element-106" data-mp="3ucx8gqzfk3bk">
            A practical 15-minute system designed to help you systematically
            review the critical areas of a complex rehabilitation case before
            moving forward.
          </p>
        </div>

        <div className="mt-10" data-id="element-107" data-mp="quvx47ur8agn">
          <CTAButton label="Get my 15-minute Case Audit™" subLabel="One payment of $27 · Instant access" data-id="element-108" data-mp="qum6ci1vxz9w" />
        </div>
      </div>
    </section>;
}